export default "__VITE_ASSET__B5Q49tIg__"